import React from 'react';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { appCondition, getCurrencySymbol, handleKettoLinks } from '../../../../services/helperFunctions';
import { sendEvents } from '../../../../redux/actions/Home';
import RightIcon from '../../../public/images/icon-right.png';
import WarningRed from '../../../public/images/warning-red.png';
import { ImgLazyload } from '../index';
import { getCookie } from '../../../../services/utilities';

const handleTransationStatus = (data, userData) => {
  const isMissed = (data && data.paymentMissing) != false;
  const statusFlag = data?.status_flag;
  const paymentStatus = data?.payment_status;
  const mode = data?.payment_mode;
  const nextPayment = data?.next_payment_date;
  const balance = userData?.wallet_balance && userData?.wallet_balance?.balance;
  const sipAmount = data?.amount;
  
  if (isMissed) {
    return 'missed';
  }
  if (paymentStatus == 2) {
    return 'change_payment_method';
  }
  if (balance > sipAmount && mode == 'KETTO_WALLET') return 'change_payment_method';
  if (balance < sipAmount && mode == 'KETTO_WALLET') { return 'add_balance'; }
  if (statusFlag == '1' && paymentStatus == '1') {
    if (dayjs(nextPayment).diff(new Date(), 'days') <= 7) {
      return mode;
    }
    return 'successful_payment';
  }

  if (mode == 'card' && paymentStatus != '1') {
    return;
  }
  return mode;
};

const hanldeRedirectToPayment = (email) => {
  const { campaign_cause } = JSON.parse(localStorage.getItem('latestorder'));
  handleKettoLinks(`new/sip/change-payment?pr=c&email=${email}&sip_cause=${campaign_cause}`);
  // const url = process.env.NODE_ENV == 'development' ? `https://dev5.ketto.org/new/sip/change-payment?pr=c&email=${email}&sip_cause=${campaign_cause}` : `https://ketto.org/new/sip/change-payment?pr=c&email=${email}&sip_cause=${campaign_cause}`;
  // window.open(url, '_blank');
};

export const TransactionStatus = (data, userData) => {
  const paymentMethod = handleTransationStatus(data, userData);
  let cardDigits = '';
  let paymentData = '';
  if (data.latestorder && data.latestorder.checksum && data.latestorder.checksum != null) {
    paymentData = data.latestorder && !data.latestorder.checksum.includes('\"') ? data.latestorder.checksum.split('@')[1] : JSON.parse(data.latestorder.checksum);
    cardDigits = paymentData && paymentData.last4 ? paymentData.last4 : '';
  }
  const amount = data && data.amount;
  // const userData = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')) : '';
  const currency = data.currency && getCurrencySymbol(data.currency.toUpperCase());
  const nextPayment = data.next_payment_date && dayjs(data.next_payment_date).diff(new Date(), 'days');
  const fundraiser = data.latestorder && data.latestorder.campaign && data.latestorder.campaign.title ? `"${data.latestorder.campaign.title.slice(0, 29)}..."` : '';
  const missingDate = data.paymentMissing;
  const email = userData && userData.email ? userData.email : '';
  const sipAmount = data?.amount;
  const payMode = data && data.payment_mode;
  const campaign_cause = data && data.campaign_cause;
  const isIOS = getCookie('platform') == 'ios';
  const walletLink = ((!isIOS && appCondition('1.0.8')) || !getCookie('platform')) ? `new/sip/wallet-recharge?currency=${data.currency && data.currency.toUpperCase()}&amount=${sipAmount}&sip_cause=${campaign_cause}` : `new/login?em=${userData.email}&to=new/sip/wallet-recharge&currency=${data.currency && data.currency.toUpperCase()}&amount=${sipAmount}&sip_cause=${campaign_cause}`;
  
  const handleFundraiserRedirect = () => {
    // if (data.latestorder.campaign.status_flag === 4) {
    //   toast.error('This fundraiser has expired', { theme: 'colored', autoClose: 5000 });
    //   return;
    // }
    if (data.latestorder.campaign.status_flag === 1 || data.latestorder.campaign.status_flag === 8) {
      window.open(handleKettoLinks(`fundraiser/${data.latestorder.campaign.custom_tag}`));
    }
  };

  const handleSystemEvent = (input1, input2, input3, input4, isCT = false) => {
    sendEvents(input1, input2, input3, input4, '', isCT).then(() => {
    })
      .catch(() => {
      });
  };

  const handleDay = (paymentDay) => {
    if (paymentDay == 0) {
      return 'today';
    }
    if (paymentDay == 1) {
      return 'in 1 day';
    }
    return `in ${paymentDay} days`;
  };

  const updateStyles = {
    padding: '10px 12.86px',
  };

  if (data && data.latestorder.campaign_id && data.latestorder.campaign_id != 54995 && data.latestorder.campaign_id != 203894 && email) {
    switch (paymentMethod) {
      case 'successful_payment': return (
        payMode !== 'KETTO_WALLET'
        && (
        <div
          className={`payment-details d-flex font-monsterArt ${fundraiser ? '' : 'd-none'}`}
          style={{
            background: '#DEF4F4', margin: '10px', padding: '10px ', borderRadius: '8px',
          }}
          onClick={() => {
            handleSystemEvent('fund_allocated_clicked', 'sip_returning', 'homepage', 'impact', true);
          }}>
          <div className="col-11">
            <div
              className="text-black"
              onClick={() => {
                handleFundraiserRedirect();
              }}>
              <p className="mb-0 text-black fs-12 lh-18">
                This month you’ve donated to the fundraiser
                {' '}
                <span className="text-bold">
                  {' '}
                  {fundraiser}
                  {' '}
                </span>
              </p>
            </div>
          </div>
          <div className="col-1 d-flex justify-content-end align-items-center">
            <div onClick={() => { handleFundraiserRedirect(); }}>
              <NavigateNextIcon width="6px" style={{ color: '#204b6b' }} />
              {/* <NavigateNextIcon width="6px" style={{color:"#204b6b"}} /> */}
            </div>
          </div>
        </div>
        )
      );
        break;
      case 'CARD': return (
        <div
          className="payment-details d-flex font-monsterArt"
          style={updateStyles}
          onClick={() => {
            handleSystemEvent('next_transaction_clicked', 'sip_returning', 'homepage', 'impact', true);
          }}>
          <div className="col-11">
            <Link className="text-black" to="/mysip">
              <p className="mb-0 text-black fs-12 lh-18">
                {`Your card ending in **** ${cardDigits} will be used for the next transaction of ${currency}${amount}`}
                {' '}
                {handleDay(nextPayment)}
              </p>
            </Link>
          </div>
          <div className="col-1 d-flex justify-content-end align-items-center">
            <Link to="/mysip">
              <NavigateNextIcon width="6px" style={{ color: '#204b6b' }} />
            </Link>
          </div>
        </div>
      );
        break;
      case 'UPIRECURRING': return (
        <div
          className="payment-details d-flex font-monsterArt"
          style={updateStyles}
          onClick={() => {
            handleSystemEvent('next_transaction_clicked', 'sip_returning', 'homepage', 'impact', true);
          }}>
          <div className="col-11">
            <Link className="text-black" to="/mysip">
              <p className="mb-0 text-black fs-12 lh-18">
                {`${data.checksum && data.checksum.split('@')[1] === 'paytm' ? 'Paytm' : 'BHIM'} will be used for the next transaction of ${currency}${amount}`}
                {' '}
                {handleDay(nextPayment)}
              </p>
            </Link>
          </div>
          <div className="col-1 d-flex justify-content-end align-items-center">
            <Link to="/mysip">
              <NavigateNextIcon width="6px" style={{ color: '#204b6b' }} />
            </Link>
          </div>
        </div>
      );
        break;
      case 'UPI': return (
        <div
            className="payment-details d-flex font-monsterArt"
            style={updateStyles}
            onClick={() => {
              handleSystemEvent('next_transaction_clicked', 'sip_returning', 'homepage', 'impact', true);
            }}>
          <div className="col-11">
            <Link className="text-black" to="/mysip">
              <p className="mb-0 text-black fs-12 lh-18">
                {`${data.checksum && data.checksum.split('@')[1] === 'paytm' ? 'Paytm' : 'BHIM'} will be used for the next transaction of ${currency}${amount}`}
                {' '}
                {handleDay(nextPayment)}
              </p>
            </Link>
          </div>
          <div className="col-1 d-flex justify-content-end align-items-center">
            <Link to="/mysip">
              <NavigateNextIcon width="6px" style={{ color: '#204b6b' }} />
            </Link>
          </div>
        </div>
      );
        break;
      case 'WALLET_RECURRING': return (
        <div
          className="payment-details d-flex font-monsterArt"
          style={updateStyles}
          onClick={() => {
            handleSystemEvent('next_transaction_clicked', 'sip_returning', 'homepage', 'impact', true);
          }}>
          <div className="col-11">
            <Link className="text-black" to="/mysip">
              <p className="mb-0 text-black fs-12 lh-18">
                {`Paytm Wallet will be used for the next transaction of ${currency}${amount}`}
                {' '}
                {handleDay(nextPayment)}
              </p>
            </Link>
          </div>
          <div className="col-1 d-flex justify-content-end align-items-center">
            <Link to="/mysip">
              <NavigateNextIcon width="6px" style={{ color: '#204b6b' }} />
            </Link>
          </div>
        </div>
      );
        break;
      case 'Emandate': return (
        <div
          className="payment-details d-flex font-monsterArt"
          style={updateStyles}
          onClick={() => {
            handleSystemEvent('next_transaction_clicked', 'sip_returning', 'homepage', 'impact', true);
          }}>
          <div className="col-11">
            <Link className="text-black" to={handleKettoLinks(`new/sip/change-payment?pr=c&email=${email}&sip_cause=${campaign_cause}`)} target="_blank">
              <p className="mb-0 text-black fs-12 lh-18">
                {`NetBanking ${paymentData && paymentData.channel_code ? paymentData.channel_code : ''} will be used for the next transaction of ${currency}${amount}`}
                {' '}
                {handleDay(nextPayment)}
              </p>
            </Link>
          </div>
          <div className="col-1 d-flex justify-content-end align-items-center">
            <Link to={handleKettoLinks(`new/sip/change-payment?pr=c&email=${email}&sip_cause=${campaign_cause}`)} target="_blank">
              <NavigateNextIcon width="6px" style={{ color: '#204b6b' }} />
            </Link>
          </div>
        </div>
      );
        break;
      case 'Simpl': return (
        <div
          className="payment-details d-flex font-monsterArt"
          style={updateStyles}
          onClick={() => {
            handleSystemEvent('next_transaction_clicked', 'sip_returning', 'homepage', 'impact', true);
          }}>
          <div className="col-11">
            <Link className="text-black" to={handleKettoLinks(`new/sip/change-payment?pr=c&email=${email}&sip_cause=${campaign_cause}`)} target="_blank">
              <p className="mb-0 text-black fs-12 lh-18">
                {`Simpl ${userData && userData.phone_1 ? userData.phone_1 : ''} will be used for the next transaction of ${currency}${amount}`}
                {' '}
                {handleDay(nextPayment)}
              </p>
            </Link>
          </div>
          <div className="col-1 d-flex justify-content-end align-items-center">
            <Link to={handleKettoLinks(`new/sip/change-payment?pr=c&email=${email}&sip_cause=${campaign_cause}`)} target="_blank">
              <NavigateNextIcon width="6px" style={{ color: '#204b6b' }} />
            </Link>
          </div>
        </div>
      );
        break;
      case 'KETTO_WALLET': return (
        <div
          className="payment-details d-flex font-monsterArt"
          style={updateStyles}
          onClick={() => {
            handleSystemEvent('next_transaction_clicked', 'sip_returning', 'homepage', 'impact', true);
          }}>
          <div className="col-11">
            <p className="mb-0 text-black fs-12 lh-18">
              {`Ketto Wallet will be used for the next transaction of ${currency}${amount}`}
              {' '}
              {handleDay(nextPayment)}
            </p>
          </div>
        </div>
      );
        break;
      case 'missed': return (
        <div
          className="payment-details d-flex"
          style={{
            background: '#FFEAED', margin: '10px', padding: '10px 12.86px', borderRadius: '8px', columnGap: '10.14px',
          }}
          onClick={() => {
            hanldeRedirectToPayment(email);
            handleSystemEvent('onetime_payment_clicked', 'sip_returning', 'homepage', 'impact', true);
          }}>
          <div>
            <Link to={handleKettoLinks(`new/sip/change-payment?pr=c&email=${email}&sip_cause=${campaign_cause}`)} target="_blank">
              <ImgLazyload src={WarningRed} alt="Warning Icon" className="icon-warning" />
            </Link>
          </div>
          <div>
            <Link className="text-black" to={handleKettoLinks(`new/sip/change-payment?pr=c&email=${email}&sip_cause=${campaign_cause}`)} target="_blank">
              <p className="mb-0 text-black font-monsterArt fs-11 lh-18">
                Oops, looks like you have&nbsp;
                missed the SIP payment
                {' '}
                for
                {' '}
                {dayjs(missingDate).format('MMM') + "'"}
                {dayjs(missingDate).format('YY')}
                {' '}
              </p>
              <div className="d-flex gap-2 align-items-center">
                <p className="text-bold mb-0 fs-11 lh-18 mt-1" style={{ color: '#444444' }}> Pay Now</p>
                <NavigateNextIcon width="6px" style={{ color: '#204b6b' }} />
              </div>
            </Link>
          </div>
        </div>
      );
        break;
      case 'change_payment_method': return (
        <div
          className="payment-details d-flex"
          style={{
            background: '#FFEAED', margin: '10px', padding: '10px 12.86px', borderRadius: '8px', columnGap: '10.14px',
          }}
          onClick={() => {
            payMode == 'KETTO_WALLET' ? handleSystemEvent('Wallet_move to recurring', 'sip_returning', 'homepage', 'impact', true)
              : handleSystemEvent('update_payment_clicked', 'sip_returning', 'homepage', 'impact', true);
          }}>
          <div>
            <Link to={payMode == 'KETTO_WALLET' ? handleKettoLinks(`new/sip/change-payment?wallet_to_autopay=1&pr=c&email=${email}&sip_cause=${campaign_cause}`) : handleKettoLinks(`new/sip/change-payment?pr=c&email=${email}&sip_cause=${campaign_cause}`)} target="_blank">
              <ImgLazyload src={WarningRed} alt="Warning Icon" className="icon-warning" />
            </Link>
          </div>
          <div>
            <Link className="text-black" to={payMode == 'KETTO_WALLET' ? handleKettoLinks(`new/sip/change-payment?wallet_to_autopay=1&pr=c&email=${email}&sip_cause=${campaign_cause}`) : handleKettoLinks(`new/sip/change-payment?pr=c&email=${email}&sip_cause=${campaign_cause}`)} target="_blank">
              <p className="mb-0 font-monsterArt fs-11 lh-18">
                Your current payment does not support recurring transaction.&nbsp;
              </p>
              <div className="d-flex gap-2 align-items-center">
                <p className="text-bold mb-0 fs-11 lh-18 mt-1 ">
                  {' '}
                  {payMode == 'KETTO_WALLET' ? 'Add an autopay mode' : 'Change Payment Mode'}
                  {' '}
                </p>
                <NavigateNextIcon width="6px" style={{ color: '#204b6b' }} />
              </div>
            </Link>
          </div>
        </div>
      );
        break;
      case 'add_balance': return (
        <div
              className="payment-details d-flex"
              style={{
                background: '#FFEAED', margin: '10px', padding: '10px 12.86px', borderRadius: '8px', columnGap: '10.14px',
              }}
              onClick={() => {
                handleSystemEvent('Wallet_Add_Balance', 'sip_returning', 'homepage', 'impact', true);
              }}>
          <div>
            <Link to={handleKettoLinks(walletLink)} target="_blank">
              <ImgLazyload src={WarningRed} alt="Warning Icon" className="icon-warning" />
            </Link>
          </div>
          <div>
            <Link className="text-black" to={handleKettoLinks(walletLink)} target="_blank">
              <p className="mb-0 font-monsterArt fs-11 lh-18">
                Your wallet balance is too low for the upcoming transaction.&nbsp;
              </p>
              <div className="d-flex gap-2 align-items-center">
                <p className="text-bold mb-0 fs-11 lh-18 mt-1 ">Add Balance</p>
                <NavigateNextIcon width="6px" style={{ color: '#204b6b' }} />
              </div>
            </Link>
          </div>
        </div>
      );
        break;
      default: return '';
        break;
    }
  }
};

export default TransactionStatus;
